import * as React from "react"
import '../styles/global.css'
import { useBrain } from "../../Brain";
import * as styles from '../styles/public.module.css'
import { StaticImage } from "gatsby-plugin-image";

export default function Public() {

  const { authReady, user, login, logout, setRedirectedFrom } = useBrain();


  return (
    <div className={styles.page}>

      <div className={styles.all}>


        <h1>ASK GEMIC</h1>

        {/* <div className={styles.box}>
          2024 TREND REPORTS EDITION
        </div> */}
        <div
          onClick={() => authReady && !user && login()}
          className={styles.box}
          style={{ opacity: authReady && !user ? 1 : 0.5, cursor: authReady && !user ? 'pointer' : 'default' }}
        >
          Login
        </div>
        {/* <StaticImage src="../images/books.png" alt="Books" className={styles.books} /> */}





      </div>
    </div>

  );
}

export { Head } from '../components/Head'
